import styled, { css } from 'styled-components';
import { ButtonV2, Hint, RadioV2 } from '@getgrover/ui';

import DeliveryBlock from 'ggApp/shared/components/cards/ProductDetailsCard/badges/Delivery/index';

import RentalPlanSelector from 'ggApp/modules/rentalPlan/components/RentalPlanSelector';
import TrialCard from 'ggApp/shared/components/cards/ProductDetailsCard/TrialCard';

type PriceProps = {
    withOldPrice: boolean;
    theme: any;
};

type ActiveProps = {
    active: boolean;
};

const Container = styled.div<ActiveProps>`
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    padding: 16px;
    background: ${({ theme }) => theme.colors.Background};
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
    ${({ active }) => !active && `cursor: pointer`};
`;

const PlanTypeWrap = styled.div<ActiveProps>`
    display: flex;
    align-items: center;
    margin-bottom: ${({ active }) => (active ? '16px' : '0px')};
`;

export const CardCheck = styled(RadioV2)`
    margin-right: 16px;
    input {
        visibility: hidden;
    }
`;

const PlanType = styled.h3`
    ${({ theme }) => theme.typography.Paragraph};
`;

const ContentWrap = styled.div`
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
`;

const PriceWrap = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 16px;
`;

const OldPrice = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    text-decoration: line-through;
    margin-right: 4px;
    display: inline;
`;

const Price = styled.h4<PriceProps>`
    ${({ theme }) => theme.typography.Headline};
    margin-right: 4px;
    ${({ withOldPrice, theme }) =>
        withOldPrice &&
        css`
            color: ${theme.colors.Color1};
        `}
`;

const PriceSuffix = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
`;

const SelectorHelpWrap = styled.div`
    display: flex;
    margin-bottom: 16px;
`;

const SelectorHelpText = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph};
`;

const SelectorHelpTriggerText = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph};
    margin-left: 2px;
    text-decoration: underline;
`;

const Selector = styled(RentalPlanSelector)`
    margin-bottom: 16px;
`;

const TrialDescription = styled(TrialCard)`
    margin-bottom: 16px;
`;

const Warning = styled(Hint)`
    margin-bottom: 16px;
`;

const Cta = styled(ButtonV2)`
    margin-bottom: 16px;
`;

const Delivery = styled(DeliveryBlock)``;

export {
    Container,
    PlanTypeWrap,
    PlanType,
    ContentWrap,
    PriceWrap,
    OldPrice,
    Price,
    PriceSuffix,
    SelectorHelpWrap,
    SelectorHelpText,
    SelectorHelpTriggerText,
    Selector,
    TrialDescription,
    Warning,
    Cta,
    Delivery,
};
